import APIClient from '@lessonnine/api-client.js';
import appConfig from '../utils/appConfig';
import http from './http';

export default () => {
  const {
    apigatewayBaseUrl,
    awsSessionEndpoint,
    awsSessionMethod
  } = appConfig.getMyConfig();

  const apiClient = new APIClient({
    baseUrl: apigatewayBaseUrl,
    awsSessionEndpoint: awsSessionEndpoint,
    awsSessionMethod: awsSessionMethod
  });

  // TODO: Remove from here, when api-client.js is extended with this method
  apiClient.authenticateWithToken = (locale, authenticationToken) => {
    return http.post(
      `${apigatewayBaseUrl}/v1.0.0/${locale}/session`,
      {},
      {
        headers: { Authorization: `Token ${authenticationToken}` }
      }
    ).then(({ response }) => response.session)
    .then((session) => {
      apiClient.session = {
        accessKey: session.access_key_id,
        secretKey: session.secret_access_key,
        sessionToken: session.session_token,
        expiration: session.expiration,
        uuid: session.uuid,
        clientClockOffset: 0
      };
      apiClient.configure();
      return apiClient;
    });
  };

  return apiClient;
};
